<template>
  <div class="div-table-itens">
    <div class="d-flex align-center py-1" style="height: 32px">
      <HabilitarCompraDistribuidaPorFilial
        v-if="!PRODUTOS_SELECIONADOS_VALIDOS.length"
        :cardSelecionado="cardSelecionado"
      />

      <template v-if="PRODUTOS_SELECIONADOS_VALIDOS.length">
        <v-menu v-if="filialCompra == -1" offset-y bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              v-bind="attrs"
              v-on="on"
              color="#042333"
              dark
              small
            >
              <v-icon left small>mdi-plus</v-icon>
              opçoes
              <span class="qtde-top-button-small">{{ PRODUTOS_SELECIONADOS_VALIDOS.length }}</span>
            </v-btn>
          </template>

          <v-list>
            <v-list-item
              class="cursor-pointer"
              @click="adicionarProdutoMultifiliaisNoCarrinho(PRODUTOS_SELECIONADOS_VALIDOS)"
            >
              <v-list-item-title>
                <v-icon left>mdi-cart</v-icon>
                Adicionar no carrinho
              </v-list-item-title>
            </v-list-item>

            <v-list-item
              class="cursor-pointer"
              @click="explodirProdutoPorFilial(PRODUTOS_SELECIONADOS_VALIDOS)"
            >
              <v-list-item-title>
                <v-icon left>mdi-eye</v-icon>
                Abrir tela de Multifiliais
              </v-list-item-title>
            </v-list-item>
          </v-list>
        </v-menu>

        <v-btn
          v-else
          color="#042333"
          @click="verificaCompraOportunidade(PRODUTOS_SELECIONADOS_VALIDOS, 'mult')"
          small dark
          class="mr-5 ml-1"
        >
          <v-icon left small>mdi-cart</v-icon>
          <span>Adicionar</span>
          <span class="qtde-top-button-small">{{ PRODUTOS_SELECIONADOS_VALIDOS.length }}</span>
          <OpcoesParaAdicionarNoCarrinho
            :produtos="PRODUTOS_SELECIONADOS_VALIDOS"
            @adicionar="produtos => {
              produtosSelecionados = produtos;
              addProdutosCarrinhoGrupo();
            }"
          />
        </v-btn>

        <ConsolidarCompraParaUmaFilial
          v-if="Number(filialCompra) === 0 && COMPRA_DISTRIBUIDA_POR_FILIAL"
          :produtos_selecionados="PRODUTOS_SELECIONADOS_VALIDOS"
          classes_css="mr-5"
          @consolidacao:filial-selecionada="consolidarCompraParaUmaFilialMulfiliais"
        />
      </template>

      <v-btn
        v-if="PRODUTOS_SELECIONADOS_VALIDOS.length"
        color="red"
        @click="setProdutoSilenciadoEditar({ produtos: PRODUTOS_SELECIONADOS_VALIDOS })"
        small dark
      >
        <v-icon left small>mdi-bell-off</v-icon>
        <span>silenciar</span>
        <span class="qtde-top-button-small">{{ PRODUTOS_SELECIONADOS_VALIDOS.length }}</span>
      </v-btn>

      <v-spacer />

      <carrinho-compra
        :buscarPedidos="buscarPedidos"
        @compraOportunidade="ativaCompraOportunidade = $event"
        @atualizarProdutosCompra="cardSelecionado.metodo(getFornecedor.id)"
      ></carrinho-compra>
    </div>

    <sys-data-table
      ref="tabelaProdutos"
      v-model="produtosSelecionados"
      :headers="HEADERS_COMPUTED"
      :items="itemsTabelaCompra"
      item-key="index"
      :items-per-page="-1"
      :fixed-header="true"
      :loading="loading"
      show-column-custom
      id-unique-preference="PERSONALIZACAO_COLUNAS_LISTA_PRODUTOS_TELA_COMPRAS_FORNECEDOR"
      class="font-resp-tabela sazonalidade-item-legenda classe-fixar-coluna-checkbox-tabela-compras"
      :item-class="classesDaLinhaDoDataTable"
      content-class="sys-data-table-gray-hover-linha"
      show-select
      :search="search"
      id="tabela-itens-compras"
      :height="ALTURA_TABELA_PRODUTOS"
      :item-height="altura_item"
      desativar_ordenacao
      @click:row="clicouNaLinha"
      @contextmenu:row="showProgrammaticallyMenu($event)"
      @scroll-items="scrollSysDataTable"
      @click:th="() => abrir_dialog_ordenacao_count++"
    >
      <template #top>
        <span class="font-16 ml-1">Produtos</span>

        <Ordenacao
          id_unico_preferencia="ORDENACAO_TABELA_LISTA_PRODUTOS_TELA_COMPRAS_GERAL"
          :itens="colunas_ordenacao"
          :abrir_dialog_ordenacao_count="abrir_dialog_ordenacao_count"
          @update:ordenacao="() => cardSelecionado.metodo(getFornecedor.id)"
          @campos:ordenacao="atualizarCamposOrdenados"
        />

        <v-spacer />

        <div style="width: 400px">
          <v-text-field
            label="Pesquisar"
            clearable
            v-model="search"
            v-lazy-input:debounce="500"
            hide-details
            class="mb-4"
          ></v-text-field>
        </div>
      </template>

      <template v-for="(item, key) in campos_em_ordenacao" #[`header.${item.campo}.icon_order`]>
        <span :key="key">
          <v-icon v-if="item.ordem === 'DECRESCENTE'" small v-text="'mdi-arrow-down'" />
          <v-icon v-else small v-text="'mdi-arrow-up'" />
        </span>
      </template>

      <template #item.data-table-select-td="{isSelecded, select, item}">
        <v-icon v-if="item.produto_esta_combinado" color="#CECECE">mdi-checkbox-blank-outline</v-icon>

        <div v-else class="cursor-pointer" @click.stop="select">
          <v-icon v-if="isSelecded" :size="24" color="primary">mdi-checkbox-marked</v-icon>
          <v-icon v-else :size="24">mdi-checkbox-blank-outline</v-icon>
        </div>
      </template>

      <template #item.sigla_grupo="{item}">
        <div class="d-flex align-center">
          <span class="pr-1">{{ siglaGrupo(item.id_grupo) }}</span>

          <div>
            <v-icon
              size="17"
              small
              title="Produto em completar compra por necessidade de abastecimento do CD"
              v-if="item.tipo === 'CD'"
              v-text="'$HomeBattery'"
            />

            <v-icon
              v-if="item.compra_transito_entregue > 0"
              small
              color="#ffd700"
              style="color: #fad30b"
              :title="`Produto em trânsito com ${Helpers.formatarValor(item.compra_transito_entregue)} ${item.unidade_compra} entregue`"
              v-text="item.icone_tipo"
              class="cursor-help"
            />

            <v-icon v-else small color="gray" :title="item.descricao_icone" v-text="item.icone_tipo"
                    class="cursor-help" />

            <v-icon v-if="item.baixa_movimentacao" :size="20" title="Produto de Baixa Movimentação" class="cursor-help">
              mdi-trending-down
            </v-icon>

            <Legenda
              v-if="item.produto_eh_combinacao"
              titulo="Produto Combinado"
              :legenda="`Este produto é uma combinação de ${item.produtos.length} produtos`"
            >
              <v-icon :size="17">mdi-vector-combine</v-icon>
            </Legenda>

            <v-icon v-if="item.projecao_vendas_personalizada" size="17">$ProjecaoVendasPersonalizada</v-icon>

            <v-icon
              v-if="item.produto_em_analise_por_lote"
              :size="16"
              :title="item.tipo === 'LT' ? 'Produto com sugestão de compra pela análise por lotes' : 'Produto em análise por lotes'"
              :color="item.tipo === 'LT' ? 'primary' : 'default'"
            >
              mdi-hexagon-multiple
            </v-icon>

            <v-icon
              small
              v-if="parseFloat(item.fator_atuacao) !== 1"
              :color="item.fator_atuacao > 1 ? 'green' : 'red'"
              :title="titleIndicadorFatorAtuacao(item.fator_atuacao)"
              v-text="item.fator_atuacao > 1 ? 'mdi-elevation-rise' : 'mdi-elevation-decline'"
            />
          </div>

          <v-spacer />

          <v-tooltip bottom content-class="tooltip-bell" open-delay="400">
            <template v-slot:activator="{ on, attrs }">
              <Legenda :titulo="item.status_descricao">
                <template #legenda>
                  <span>
                    {{ item.descritivo }}
                  </span>
                </template>
                <v-btn v-bind="attrs" v-on="on" icon class="ml-n1">
                  <v-icon
                    small
                    :style="{color: item.cor}"
                    v-text="'mdi-bell-off'"
                    @click="setProdutoSilenciadoEditar(item)"
                  />
                </v-btn>
              </legenda>
            </template>
          </v-tooltip>

        </div>
      </template>

      <template #item.cod_produto="{item}">
        <p v-text="item.cod_produto" :title="item.cod_produto" class="text-truncate ma-0 cursor-help" />
      </template>

      <template #item.unidade_compra="{item}">
        {{ embalagemMasterAtivada ? item.unidade_master : item.unidade_compra }}
      </template>

      <template #item.tempo_gatilho="{item}">
        <div class="text-center ml-n2">
          <span v-if="item.tempo_gatilho > 0" style="color: green" v-text="`+ ${item.tempo_gatilho}`" />
          <span v-else-if="item.tempo_gatilho < 0" style="color: red" v-text="`- ${Math.abs(item.tempo_gatilho)}`" />
          <span v-else>Hoje</span>
        </div>
      </template>

      <template #item.estoque="{value}">
        {{ Helpers.formatarValor(value) }}
      </template>

      <template #item.preco_compra="{ item }">
        <FormatarMoeda :tipo="item.moeda" />
        {{ Helpers.formatarValorComCasas(item.preco_compra, 2) }}
      </template>

      <template #item.cobertura_est_futura="{item}">
        <calc-cobertura-estoque :item="item" />
      </template>

      <template #item.estoque_transito="{value}">
        {{ Helpers.formatarValor(value) }}
      </template>

      <template #item.descricao_produto="{item}">
        <div class="d-flex align-center">
          <ComparacaoProdutos
            v-if="item.produto_eh_combinacao"
            :id_grupo="item.id_grupo"
            :filial="item.filial"
            :id_produto_combinado="String(item.idproduto)"
            :produtos="item.produtos"
            icon="mdi-information-outline"
            :size_icon="15"
            content_button_activator="ml-n3 mr-n2"
          />

          <v-tooltip v-if="`${item.detalhamento_tecnico || ''}`.length > 0" bottom open-delay="500">
            <template v-slot:activator="{on, attrs}">
              <span v-bind="attrs" v-on="on" v-text="item.descricao_produto" class="text-truncate" />
            </template>

            <div class="font-12" style="max-width: 500px">
              <p class="ma-0 font-weight-bold">Detalhamento técnico do produto</p>
              <p class="ma-0" v-text="item.detalhamento_tecnico" />
            </div>
          </v-tooltip>

          <span v-else v-text="item.descricao_produto" class="text-truncate" />
        </div>
      </template>

      <template #item.status_transito="{value}">
        <div class="d-flex align-center">
          {{ value }}
          <AlertaDeQtdSugestao />
        </div>
      </template>

      <template #header.sugestao_em_litragem>
        {{ CONFIG_FORNECEDOR.tipo_litragem === 'LT' ? 'Sugestão em litro' : 'Sugestão em galão' }}
      </template>

      <template #header.classificacao_criticidade.text="{header}">
        <HeaderCurvaAbc :header="header">
          <LegendaCurvaAbcFaturamento top>{{ header.text }}</LegendaCurvaAbcFaturamento>
        </HeaderCurvaAbc>
      </template>

      <template #header.classificacao_rentabilidade.text="{header}">
        <HeaderCurvaAbc :header="header">
          <LegendaCurvaAbcRentabilidade top :texto="header.text" />
        </HeaderCurvaAbc>
      </template>

      <template #item.classificacao_criticidade="{value}">
        <LegendaCurvaAbcFaturamento :texto="value" />
      </template>

      <template #item.classificacao_rentabilidade="{value}">
        <LegendaCurvaAbcRentabilidade :texto="value" />
      </template>

      <template #item.sugestao_em_litragem="{item}">
        <GalonagemProduto :produto="{...item, tipo_litragem: CONFIG_FORNECEDOR.tipo_litragem}" />
      </template>

      <template #item.compra_em_palete="{ item }">
        <CompraEmPalete
          :lastro_palete="Number(item.lastro_palete)"
          :altura_palete="Number(item.altura_palete)"
          :quantidade_compra="Number(item.sugestao)"
          :unidade_compra="embalagemMasterAtivada ? item.unidade_master : item.unidade_compra"
        />
      </template>

      <template #item.sugestao="{item}">
        <div class="d-flex align-center">
          <div>
            <div v-if="item.status_transito" class="text-center">
              {{ Helpers.formatarValor(item.sugestao) }}
            </div>

            <template v-else>
              <sys-input-formatador
                v-model="item.sugestao"
                :id="item.id_grupo + item.idproduto"
                :ref="item.id_grupo + item.idproduto"
                :max-digitos="QTDE_DECIMAIS"
                :removerValorIrrelevante="true"
                centralizar
                :disabled="desabilitarInputSugestao || item.produto_esta_combinado"
                class="input-regular font-resp w-100"
                @keydown.down="navegacaoLinhasPelasSetas(item, 1, $event)"
                @keydown.up="navegacaoLinhasPelasSetas(item, -1, $event)"
                @keyup.right="getDetalhesProdutoGrupo(item)"
                @keyup.left="$emit('voltar-exibir-graficos-tela-compras')"
                @focus="$event.target.select()"
                @keyup.enter="addProdutosCarrinhoGrupo([item])"
              >
                <template #sufixo>
                  <div
                    v-if="Number(item.estoque_pendente) > 0"
                    class="position-absolute font-11 text-green left-auto right-0 top-2px cursor-help"
                    :title="`Venda futura de ${Helpers.formatarValor(item.estoque_pendente)}`"
                  >
                    +{{ Helpers.formatarValor(item.estoque_pendente) }}
                  </div>
                </template>
              </sys-input-formatador>
            </template>
          </div>

          <div class="d-flex align-center" v-if="!item.status_transito">
            <CompraProdutoNaoConfirmadaNoERP
              v-if="item.compra_produto_nao_confirmada_no_erp"
              :id_grupo="Number(item.id_grupo)"
              :produto_eh_combinacao="item.produto_eh_combinacao"
              :idproduto="String(item.idproduto)"
              @fazer-novo-pedido-compra="() => item.compra_produto_nao_confirmada_no_erp = false"
            />

            <DistribuirCompraPorFilial
              v-else-if="COMPRA_DISTRIBUIDA_POR_FILIAL && !item.produto_esta_combinado"
              v-model="multifilial_ocultar_produtos_carrinho"
              :produto="{...item, idfornecedor: getFornecedor.id}"
              :card_completar_compra="cardSelecionado.chave_card === 'completar_compra'"
              @click.stop
              @atualizar-listagem-produtos="atualizarPedidosCarrinho();cardSelecionado.metodo(getFornecedor.id);"
            />

            <template v-else-if="filialCompra > -1">
              <ValidaLoteMinimo
                :ref="`estoqueMinimo-${item.id_grupo}-${item.idproduto}-ref`"
                v-if="!verificaSeMultiploDeLoteMinimo(item)"
                v-model.number="item.sugestao"
                :lote-minimo="item.lote_minimo"
                @change="validarQuantidadeCompra(item)"
                @forcar-sugestao="addCarrinhoGrupo(item)"
              />

              <SugestaoEstoqueEstetico
                v-else-if="!verificaSeSurgestaoEstoqueMinimo(item) && item.sugestao > 0"
                :ref="`estoqueEstetico-${item.id_grupo}-${item.idproduto}-ref`"
                v-model.number="item.sugestao"
                :estoque="Number(item.estoque)"
                :estoque_transito="Number(item.estoque_transito)"
                :estoque_minimo="Number(item.estoque_minimo)"
                @change="validarQuantidadeCompra(item, false)"
              />

              <ValidacaoSugestaoVendaFutura
                v-else-if="!verificarVendaFuturaValida(item)"
                :ref="`alerta-venda-futura-${item.id_grupo}-${item.idproduto}-ref`"
                :quantidade_compra="Number(item.sugestao)"
                :quantidade_sugestao="Number(item.sugestao_fixa_convertivel)"
                :quantidade_venda_futura="Number(item.estoque_pendente)"
                @aplicar-valor="valor => {
                  item.nao_validar_venda_futura = true;
                  item.sugestao = valor;
                  validarQuantidadeCompra(item);
                }"
              />

              <template v-else>
                <v-btn
                  :disabled="parseFloat(item.sugestao || 0) <= 0 || item.produto_esta_combinado"
                  icon
                  @click.stop="verificaCompraOportunidade([item])"
                >
                  <v-icon>mdi-cart</v-icon>
                </v-btn>
              </template>
            </template>

            <template v-else>
              <div class="d-flex align-center">
                <v-btn icon @click.stop="explodirProdutoPorFilial([item])">
                  <v-icon>mdi-eye</v-icon>
                </v-btn>

                <template v-if="parseFloat(item.sugestao) > 0">
                  <v-btn
                    icon
                    :disabled="item.produto_esta_combinado"
                    @click.stop="adicionarProdutoMultifiliaisNoCarrinho([item])"
                  >
                    <v-icon>mdi-cart</v-icon>
                  </v-btn>
                </template>
              </div>
            </template>

            <DetalhamentoSugestaoCompra
              content_class="ml-n2"
              :produto="{
                ...item,
                sugestao: getQtdePedidoConvertida(item),
                filial: filialCompra
              }"
              :card_completar_compra="cardSelecionado.chave_card === 'completar_compra'"
            />
          </div>
        </div>
      </template>

      <template #footer="{countItems}">
        <RodapeTabela
          v-model="multifilial_ocultar_produtos_carrinho"
          :qtdItens="countItems"
          @abrir-dialog-sazonalidades="sazonalidade.dialog = true"
        />
      </template>

    </sys-data-table>

    <!-- Dialog Silenciar notificação produto -->
    <silenciar-produto />

    <v-layout>
      <v-dialog v-model="dialogMotivosCompra" width="500" persistent>
        <v-card>
          <v-card-title ss="headline grey lighten-2" primary-title
          >Compra de Oportunidade
          </v-card-title
          >
          <v-card-text>
            <v-autocomplete
              v-model="selects.motivosCompra.values"
              :items="selects.motivosCompra.items"
              item-value="id"
              item-text="descricao"
              label="Motivo (os) de Compra"
              placeholder="Selecione um ou mais motivos para esta compra"
              class="mt-2"
              outlined
              chips
              small-chips
              multiple
              :error-messages="motivosCompraErrors"
              @input="$v.selects.motivosCompra.values.$touch()"
              @blur="$v.selects.motivosCompra.values.$touch()"
            ></v-autocomplete>
            <p style="text-align: justify">
              Quantidade divergente da Sugerida. Selecione motivos que
              justifique esta tomada de decisão.
            </p>
            <div
              v-if="armazenaItem.acaoCompraOportunidade == 'mult'"
              style="text-align: justify"
            >
              <p style="margin-bottom: 0; font-weight: bold">
                <v-icon>mdi-alert</v-icon>
                <span> ATENÇÃO</span>
              </p>
              Esses Motivos justificam todos os Produtos selecionados com
              Quantidade divergente da Sugerida.
            </div>
          </v-card-text>
          <v-divider></v-divider>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="primary" text @click="fecharDialogMotivoCompra()"
            >Fechar
            </v-btn
            >
            <v-btn
              v-if="armazenaItem.acaoCompraOportunidade == 'mult'"
              color="primary"
              text
              @click="addProdutosCarrinhoGrupo()"
            >Salvar
            </v-btn
            >
            <v-btn
              v-else
              color="primary"
              text
              @click="addCarrinhoGrupo(armazenaItem)"
            >Salvar
            </v-btn
            >
          </v-card-actions>
        </v-card>
      </v-dialog>

      <dialog-compra-multifiliais
        v-model="dialogCompraMultifiliais"
        :produtos="produtosPorMultifiliais"
        :addComSucesso="produtosMultifiliaisAddComSucesso"
        @adicionar-produto-carrinho="addProdutosCarrinhoMultifiliais($event)"
        :completarCompra="cardSelecionado.titulo === 'Completar a Compra'"
      ></dialog-compra-multifiliais>
    </v-layout>

    <v-menu
      v-model="menu.show"
      :position-x="x"
      :position-y="y"
      absolute
      offset-y
    >
      <div class="bg-white" style="width: 220px">
        <div class="px-1 py-2">
          <v-icon left small>mdi-format-list-bulleted</v-icon>
          <span class="caption font-weight-medium">Lista de Opções</span>
        </div>

        <v-divider />

        <template v-for="(item, index) in menu.items">
          <div
            :key="index"
            class="d-flex align-center py-2 px-1 cursor-pointer mouse-gray-hover"
            @click="actionBtnMenu(item.value)"
          >
            <v-icon left v-text="item.icon" small />
            <span class="caption">{{ item.title }}</span>
          </div>
        </template>
      </div>
    </v-menu>

    <SysDialogFullScreen
      v-model="sazonalidade.dialog"
      titulo="Sazonalidades"
      transition="dialog-bottom-transition"
      @click:hidden-dialog="sazonalidade.cadastro = false; sazonalidade.principal = false;"
    >
      <Sazonalidade
        :dialogSazonalidade="sazonalidade.principal"
        :open_dialog_nova_sazonalidade="sazonalidade.cadastro"
        @fechar-dialog-sazonalidade="sazonalidade.dialog = false; sazonalidade.cadastro = false; sazonalidade.principal = false;"
        @fechar-dialog-nova-sazonalidade="sazonalidade.dialog = false; sazonalidade.cadastro = false; sazonalidade.principal = false;"
      />
    </SysDialogFullScreen>

    <CompararProdutos v-model="dialog_comparar_produtos" />
  </div>
</template>
<script>
import api from "@/api/api";
import ConsolidarCompraParaUmaFilial from "@/components/compra/CompraDistribuidaPorFilial/DistribuirCompraPorFilial/ConsolidarCompraParaUmaFilial.vue";
import DistribuirCompraPorFilial from "@/components/compra/CompraDistribuidaPorFilial/DistribuirCompraPorFilial/Index.vue";
import HabilitarCompraDistribuidaPorFilial from "@/components/compra/CompraDistribuidaPorFilial/HabilitarCompraDistribuidaPorFilial";
import HeaderCurvaAbc from "@/components/compra/detalhesProduto/CurvaABC/HeaderCurvaAbc.vue";
import GalonagemProduto from "@/components/compra/fornecedor/GalonagemProduto/Index";
import { colunas_ordenacao } from "@/components/compra/ProdutosGerais/ListaProdutos/Cabecalhos";
import OpcoesParaAdicionarNoCarrinho from "@/components/compra/ProdutosGerais/ValidacaoSugestao/OpcoesParaAdicionarNoCarrinho.vue";
import ValidacaoSugestaoVendaFutura from "@/components/compra/ProdutosGerais/ValidacaoSugestao/VendaFutura/Index.vue";
import CompararProdutos from "@/components/compra/tabelaProdutos/CompararProdutos/Index";
import CompraProdutoNaoConfirmadaNoERP from "@/components/produto/CompraProdutoNaoConfirmadaNoERP.vue";
import DetalhamentoSugestaoCompra from "@/components/produto/Compras/DetalhamentoSugestao/Index.vue";
import ComparacaoProdutos from '@/components/produto/DemandaCombinada/ComparacaoProdutos/Index.vue';
import Ordenacao from "@/components/utils/dataTable/Ordenacao.vue";
import { logout } from "@/helpers";
import { mapGetters, mapMutations, mapState } from "vuex";
import Responsividade from '../../helpers/ResponsiveHeight';
import Sazonalidade from '../cadastros/sazonalidade/Sazonalidade.vue';
import SysDialogFullScreen from '../padraoDeLayout/SysDialogFullScreen.vue';
import Legenda from "../produto/detalhes/Legenda.vue";
import SilenciarProduto from "../produtoSilenciado/Editar";
import FormatarMoeda from "../utils/FormatarMoeda.vue";
import sysInputFormatador from "../utils/InputFormatadorDeValor";
import CarrinhoAPI from "./../../api/carrinho";
import CompraAPI from "./../../api/compra";
import calcCoberturaEstoque from './CalculaCoberturaEstoqueFutura';
import carrinhoCompra from "./carrinho/Index";
import LegendaCurvaAbcFaturamento from "./detalhesProduto/CurvaABC/LegendaCurvaAbcFaturamento.vue";
import LegendaCurvaAbcRentabilidade from "./detalhesProduto/CurvaABC/LegendaCurvaAbcRentabilidade.vue";
import mixinCompra from './MixinCompra';
import DialogCompraMultifiliais from './multifiliais/ListaProdutosDialog';
import mixinMultifiliais from './multifiliais/Mixin';
import SugestaoEstoqueEstetico from "./SugestaoEstoqueEstetico";
import AlertaDeQtdSugestao from "./tabelaProdutos/AlertaDeQtdSugestao";
import RodapeTabela from "./tabelaProdutos/RodapeTabela";
import ValidaLoteMinimo from "./ValidaLoteMinimo";
import CompraEmPalete from "@/components/compra/ProdutosGerais/Carrinho/ListaProdutos/CompraEmPalete.vue";

export default {
  mixins: [mixinCompra, mixinMultifiliais, Responsividade],
  components: {
    CompraEmPalete,
    ConsolidarCompraParaUmaFilial,
    OpcoesParaAdicionarNoCarrinho,
    ValidacaoSugestaoVendaFutura,
    Ordenacao,
    CompraProdutoNaoConfirmadaNoERP,
    HeaderCurvaAbc,
    LegendaCurvaAbcFaturamento,
    LegendaCurvaAbcRentabilidade,
    GalonagemProduto,
    DistribuirCompraPorFilial,
    AlertaDeQtdSugestao,
    RodapeTabela,
    SilenciarProduto,
    carrinhoCompra,
    sysInputFormatador,
    SugestaoEstoqueEstetico,
    ValidaLoteMinimo,
    DialogCompraMultifiliais,
    calcCoberturaEstoque,
    SysDialogFullScreen,
    Sazonalidade,
    HabilitarCompraDistribuidaPorFilial,
    CompararProdutos,
    Legenda,
    DetalhamentoSugestaoCompra,
    ComparacaoProdutos,
    FormatarMoeda
  },
  props: [
    "cardSelecionado",
    "atualizarProdutos",
    "atualizarTelaCompras",
    "detalhesFornecedor"
  ],
  data() {
    return {
      altura_item: 50,
      selects: {
        motivosCompra: {
          items: [],
          values: [],
        },
      },
      search: "",
      filiais: [],
      // dialogFiliais: true,
      selectedId: -1,
      produtosSelecionados: [],
      headerTooltips: {
        idproduto: "ID do Produto",
        unidade_compra: "Unidade de Compra",
      },
      armazenaItem: {},
      ativarAtualizacaoDetalhesProduto: false,
      qtdeItensComprar: 0,
      dialogMotivosCompra: false,
      ativaCompraOportunidade: "",
      qtdeInicialProdutoSilenciado: "",
      buscarPedidos: 0,
      dialogCompraMultifiliais: false,
      produtosPorMultifiliais: [],
      produtosMultifiliaisAddComSucesso: false,

      x: 0,
      y: 0,
      menu: {
        show: false,
        items: [
          // { title: 'Sazonalidade', value: 'sazonalidade', icon: 'mdi-history' },
          { title: 'Comparar Produtos', value: 'comparar-produtos', icon: 'mdi-compare' },
        ],
      },
      dialog_comparar_produtos: false,
      sazonalidade: {
        dialog: false,
        principal: false,
        cadastro: false
      },
      time_focus: null,
      produto_selecionado_navegacao_setas: null,
      time_reset: null,
      multifilial_ocultar_produtos_carrinho: localStorage.flag_multifiliais_ocultar_produto_carrinho === 'S',
      colunas_ordenacao: colunas_ordenacao,
      abrir_dialog_ordenacao_count: 0,
      campos_em_ordenacao: [],
    };
  },

  validations: {
    selects: {
      motivosCompra: {
        values: {
          required() {
            if (this.dialogMotivosCompra) {
              return this.selects.motivosCompra.values.length > 0
            } else {
              return true;
            }
          },
        },
      },
    },
  },

  created() {
    this.cardSelecionado.metodo(this.getFornecedor.id);
    this.qtdeItensComprar = this.tabelaCompra.length;

    if (this.getFornecedor.produto) {
      this.search = this.getFornecedor.produto.id_produto
    }
  },
  computed: {
    ...mapGetters({
      getFornecedor: "fornecedor/getFornecedor",
      tabelaCompra: "tabela_compra/getItensCarrinhoZero",
      grupoCompra: "usuario/getGrupoCompras",
      gruposCompra: "usuario/getGrupos",
      filialCompra: "usuario/getFilialCompras",
      loading: "loading/getLoadingTable",
      comprador: "fornecedor/getComprador",
      activityLog: "activityLog/getLog",
      configuracoes: "configuracoes/carrinho",
      segmentosCompra: "segmentosCompra/getItens",
      linhasCompra: "linhasCompra/getItens",
      marcasCompra: "MarcasCompra/getItens",
      embalagemMasterAtivada: "EmbalagemTelaDeCompras/getEmbalagemMaster",
      detalhesProduto: "detalhe_produto/getProduto",
      ATUALIZAR_DETALHES_PRODUTO: "detalhe_produto/getAtualizarDetalhes",
      resetProdutosSelecionados: "ProdutosSelecionados/getResetProdutosSelecionados",
      getFecharDialogSazonalidade: "tabelaProduto/getFecharDialogSazonalidade",
      COMPRA_DISTRIBUIDA_POR_FILIAL: "CompraDistribuidaPorFilial/get_distribuir_por_filial",
      CONSIDERAR_ESTOQUE_GRUPO_COMPRA_MULTI_FILIAL: "CompraDistribuidaPorFilial/get_considerar_estoque_grupo",
      FILTROS_TODOS_PRODUTOS: "filtrosProdutos/get_state",
      PRODUTO_ULTIMO_CLICK: "tabelaProduto/getProdutoUltimoClick",
      COUNT_ULTIMO_CLICK: "tabelaProduto/getCountSimularUltimoClick",
      CONFIG_FORNECEDOR: "fornecedor/getConfig",
      FLAG_EXIBIR_APENAS_COMBINACOES_COMPUTED: 'ProdutosCombinados/exibir_apenas_combinacoes',
      GET_HISTOGRAMAS_STORE: "CompraProdutosGerais/getHistogramas",
      GET_STATUS_STORE: "CompraProdutosGerais/getStatus",
      GET_APLICACAO_STORE: "CompraProdutosGerais/getAplicacao",
    }),
    ...mapGetters("notificacaoProdutoSilenciado", ["produtoSilenciadoQtde"]),
    ...mapState("app", ["dialogProdutosSilenciados", "dialogSilenciarProduto"]),
    motivosCompraErrors() {
      const errors = [];
      if (!this.$v.selects.motivosCompra.values.$dirty) return errors;
      !this.$v.selects.motivosCompra.values.required &&
      errors.push("Campo Obrigatório.");
      return errors;
    },
    HEADERS_COMPUTED() {
      let cabecalhos = this.cardSelecionado.headers.map(head => ({ ...head }));

      if (localStorage.analiseGrupoFornecedores !== 'S') {
        cabecalhos = cabecalhos.filter(item => item.value !== 'razao_social');
      }

      if (!this.CONFIG_FORNECEDOR.calcular_litragem) {
        cabecalhos = cabecalhos.filter(item => !['descricao_linha', 'sugestao_em_litragem'].includes(item.value));
      }

      if (localStorage.ativar_exibicao_campo_numero_original !== 'S') {
        cabecalhos = cabecalhos.filter(item => item.value !== 'numero_original');
      }

      return cabecalhos;
    },
    ITEMS_TABELA_COMPRA_POR_FILTROS_DROP_DOWN() {
      let itens = this.tabelaCompra;

      if (this.segmentosCompra.length > 0) {
        const callback = item => this.segmentosCompra.some(seg => `${ seg }` === `${ item.iddepartamento }`) || item.produto_eh_combinacao;
        itens = itens.filter(callback);
      }

      if (this.linhasCompra.length > 0) {
        const callback = item => this.linhasCompra.some(linha => `${ linha }` === `${ item.idlinhaprod }`) || item.produto_eh_combinacao;
        itens = itens.filter(callback);
      }

      if (this.marcasCompra.length > 0) {
        const callback = item => this.marcasCompra.some(linha => `${ linha }` === `${ item.idmarca }`) || item.produto_eh_combinacao;
        itens = itens.filter(callback);
      }

      return itens;
    },
    ITEMS_FILTRADOS_POR_FLAG_MULTIFILIAL() {
      if (!this.COMPRA_DISTRIBUIDA_POR_FILIAL) {
        return this.ITEMS_TABELA_COMPRA_POR_FILTROS_DROP_DOWN;
      }

      if (!this.multifilial_ocultar_produtos_carrinho) {
        return this.ITEMS_TABELA_COMPRA_POR_FILTROS_DROP_DOWN;
      }

      const callback_filtro = produto => !(produto.qtd_pedidos_filial_com_produto > 0)
      return this.ITEMS_TABELA_COMPRA_POR_FILTROS_DROP_DOWN.filter(callback_filtro);
    },
    itemsTabelaCompra() {
      let itens = this.ITEMS_FILTRADOS_POR_FLAG_MULTIFILIAL;

      if (this.cardSelecionado.filtros) {
        // if (!this.FILTROS_TODOS_PRODUTOS.exibir_produtos) {
        //   return []
        // }

        if (this.FILTROS_TODOS_PRODUTOS.filtros.length > 0) {
          itens = this.ITEMS_FILTRADOS_POR_FLAG_MULTIFILIAL.filter(this.callbackAplicarFiltros);
        }
      }

      if (this.FLAG_EXIBIR_APENAS_COMBINACOES_COMPUTED) {
        itens = itens.filter(item => item.produto_eh_combinacao);
      }

      return itens;
    },
    QTDE_DECIMAIS() {
      return this.configuracoes.CASAS_DECIMAIS_CARRINHO
    },
    desabilitarInputSugestao() {
      return parseInt(this.filialCompra) === -1;
    },
    ALTURA_TABELA_PRODUTOS() {
      return parseInt(this.alturaDaJanela - 315);
    },
    PRODUTOS_SELECIONADOS_VALIDOS() {
      if (!this.produtosSelecionados || !this.produtosSelecionados.length) return [];
      return this.produtosSelecionados.filter(item => !item.produto_esta_combinado);
    },
    EXIBIR_PRODUTOS_INATIVOS_STORE() {
      return this.$store.getters['CompraProdutosGerais/getExibirProdutosInativos'];
    },
    simularClickProdutoSignal() {
      return this.$store.getters['tabelaProduto/getProdutoClicado'];
    },
  },

  watch: {
    simularClickProdutoSignal() {
      const linha = {
        expand: {
          length: 0,
          name: "bound expand"
        },
        isExpanded: false,
        row: this.PRODUTO_ULTIMO_CLICK
      };

      this.$store.dispatch('tabelaProduto/setProdutoUltimoClick', linha.row);
      this.clicouNaLinha(linha)
    },
    ATUALIZAR_DETALHES_PRODUTO() {
      this.getDetalhesProdutoGrupo(this.PRODUTO_ULTIMO_CLICK);
    },
    COUNT_ULTIMO_CLICK() {
      this.atualizarDetalhesProdutoGrupo(this.PRODUTO_ULTIMO_CLICK);
    },
    filialCompra: function () {
      this.recarregarProdutosDataTable();
    },
    grupoCompra: function () {
      this.recarregarProdutosDataTable();
    },
    EXIBIR_PRODUTOS_INATIVOS_STORE: function () {
      this.recarregarProdutosDataTable();
    },
    GET_HISTOGRAMAS_STORE() {
      this.recarregarProdutosDataTable();
    },
    GET_STATUS_STORE() {
      this.recarregarProdutosDataTable();
    },
    GET_APLICACAO_STORE() {
      this.recarregarProdutosDataTable();
    },
    getFornecedor: function () {
      this.cardSelecionado.metodo(this.getFornecedor.id, this.grupoCompra);
      this.produtosSelecionados = [];
      this.ativarAtualizacaoDetalhesProduto = false;
    },
    cardSelecionado: function () {
      if (!this.cardSelecionado.filtros) {
        this.selectedId = "";
        this.ativarAtualizacaoDetalhesProduto = false;
        this.cardSelecionado.metodo(this.getFornecedor.id, this.grupoCompra);
      } else {
        this.$store.dispatch("tabela_compra/setItems", []);
      }
    },
    atualizarProdutos() {
      if (typeof this.atualizarProdutos == "number") {
        this.cardSelecionado.metodo(this.getFornecedor.id);
      } else {
        this.getDetalhesProdutoGrupo(this.armazenaItem);
      }
    },
    tabelaCompra() {
      if (
        this.tabelaCompra.length > 0 &&
        this.tabelaCompra.length != this.qtdeItensComprar
      ) {
        this.qtdeItensComprar = this.tabelaCompra.length;
        this.verificarAtualizacaoDetalhesProduto()
      } else if (this.tabelaCompra.length == 0) {
        this.mostrarDetalhesDoFornecedor(true);
      }
      this.produtosSelecionados = [];
    },
    produtoSilenciadoQtde() {
      if (this.qtdeInicialProdutoSilenciado == "") {
        this.qtdeInicialProdutoSilenciado = this.produtoSilenciadoQtde;
      }

      if (this.qtdeInicialProdutoSilenciado != this.produtoSilenciadoQtde) {
        this.selectedId = "";
        this.cardSelecionado.metodo(this.getFornecedor.id);
        this.produtosSelecionados = [];

        this.mostrarDetalhesDoFornecedor(true);
        this.ativarAtualizacaoDetalhesProduto = false;
      }
    },
    dialogProdutosSilenciados() {
      if (!this.dialogProdutosSilenciados) {
        this.selectedId = "";
        this.produtosSelecionados = [];
        this.cardSelecionado.metodo(this.getFornecedor.id);
        this.mostrarDetalhesDoFornecedor(true);
        this.ativarAtualizacaoDetalhesProduto = false;
      }
    },
    dialogSilenciarProduto() {
      if (!this.dialogSilenciarProduto) {
        this.selectedId = "";
        this.produtosSelecionados = [];
        this.cardSelecionado.metodo(this.getFornecedor.id);
        this.mostrarDetalhesDoFornecedor(true);
        this.ativarAtualizacaoDetalhesProduto = false;
      }
    },
    atualizarTelaCompras() {
      this.cardSelecionado.metodo(this.getFornecedor.id);
    },
    detalhesFornecedor() {
      if (this.detalhesFornecedor) {
        this.activerow({ grupo: 0, idproduto: 0 });
      }
    },
    activityLog() {
      const FUNCTION = this.activityLog.function;

      if (typeof this[FUNCTION] == "function") {
        const attributes = this.activityLog.properties.attributes[0]
          ? this.activityLog.properties.attributes[0]
          : this.activityLog.properties.attributes

        this[FUNCTION](attributes);
      }
    },
    'FILTROS_TODOS_PRODUTOS.exibir_produtos': function (exibir_produtos) {
      if (this.tabelaCompra.length === 0 && exibir_produtos) {
        this.selectedId = "";
        this.ativarAtualizacaoDetalhesProduto = false;
        this.cardSelecionado.metodo(this.getFornecedor.id, this.grupoCompra);
      }
    },
    produtosSelecionados() {
      localStorage.setItem("itemSelect", JSON.stringify(this.PRODUTOS_SELECIONADOS_VALIDOS));

      this.produtosSeleciondosVuex(this.PRODUTOS_SELECIONADOS_VALIDOS);
      this.qtdeProdutosSeleciondosVuex(this.PRODUTOS_SELECIONADOS_VALIDOS.length);
    },
    dialogCompraMultifiliais() {
      if (!this.dialogCompraMultifiliais) {
        this.produtosSelecionados = []
        this.buscarPedidos++
        this.cardSelecionado.metodo(this.getFornecedor.id)
      }
    },

    resetProdutosSelecionados() {
      this.produtosSelecionados = [];
      this.$emit('atualizarTabela');
    },

    getFecharDialogSazonalidade() {
      this.sazonalidade.dialog = false;
    }
  },
  destroyed() {
    this.$store.dispatch("tabela_compra/resetColunasEmOrdenacaoCombinada");
  },
  methods: {
    ...mapMutations({
      ATUALIZAR_PRODUTO_SELECIONADO_MENU_CONTEXTO: "tabelaProduto/SET_PRODUTO_SELECIONADO_MENU_CONTEXTO"
    }),
    recarregarProdutosDataTable() {
      this.cardSelecionado.metodo(this.getFornecedor.id, this.grupoCompra);
      this.produtosSelecionados = [];

      this.ativarAtualizacaoDetalhesProduto = false;
      this.activerow({ grupo: 0, idproduto: 0 });
    },
    callbackAplicarFiltros(produto) {
      const callback = filtro => {
        if (filtro.callback_filtro) {
          return filtro.callback_filtro(produto);
        }

        return produto[filtro.chave] === true;
      }

      return this.FILTROS_TODOS_PRODUTOS.filtros.some(callback);
    },
    validarQuantidadeCompra(produto, validar_estoque_minimo = true) {
      if (!(Number(produto.sugestao) > 0)) return;

      this.$nextTick(() => {
        if (!this.verificaSeMultiploDeLoteMinimo(produto)) {
          this.ativarAlertaLoteMinimoProduto(produto);
          produto.nao_validar_venda_futura = false;
          return;
        }

        if (validar_estoque_minimo && !this.verificaSeSurgestaoEstoqueMinimo(produto)) {
          this.ativarAlertaEstoqueEsteticoProduto(produto);
          produto.nao_validar_venda_futura = false;
          return;
        }

        if (produto.nao_validar_venda_futura === true && !this.verificarVendaFuturaValida(produto)) {
          this.ativarAlertaVendaFutura(produto);
          return;
        }

        this.verificaCompraOportunidade([produto]);
      })
    },
    ativarAlertaLoteMinimoProduto(produto) {
      const estoqueExteticoRef = `estoqueMinimo-${ produto.id_grupo }-${ produto.idproduto }-ref`;

      if (this.$refs[estoqueExteticoRef]) {
        this.$refs[estoqueExteticoRef].ativador_menu = true;
      }
    },
    ativarAlertaEstoqueEsteticoProduto(produto) {
      const estoqueExteticoRef = `estoqueEstetico-${ produto.id_grupo }-${ produto.idproduto }-ref`;

      setTimeout(() => {
        if (this.$refs[estoqueExteticoRef]) {
          this.$refs[estoqueExteticoRef].ativador_menu = true;
        }
      }, 300);
    },
    ativarAlertaVendaFutura(produto) {
      const vendaFuturaRef = `alerta-venda-futura-${ produto.id_grupo }-${ produto.idproduto }-ref`;

      setTimeout(() => {
        if (this.$refs[vendaFuturaRef]) {
          this.$refs[vendaFuturaRef].menu_ativo = true;
        }
      }, 300);
    },
    classesDaLinhaDoDataTable(linha) {
      const { id_grupo, idproduto } = linha;

      const pintar_texto_cinza = (this.COMPRA_DISTRIBUIDA_POR_FILIAL && linha.qtd_pedidos_filial_com_produto > 0)
        || linha.produto_esta_combinado
        || linha.compra_produto_nao_confirmada_no_erp;

      const classesCSS = {
        'cursor-pointer': true,
        'sys-data-table-gray-linha': false,
        // 'sazonalidadee': false,
        // 'sazonalidade_default': true,
        'text-gray-100': pintar_texto_cinza,
        'text-orange': linha.revenda_produtos_compras_grupo == 'N',
        'text-red': linha.status_produtos_compras_grupo == 'FL',
      };

      if (id_grupo + idproduto === this.selectedId) {
        classesCSS['sys-data-table-gray-linha'] = true;
      }

      if (linha.sazonalidade) {
      }

      return classesCSS
    },
    clicouNaLinha(linha) {
      this.$store.dispatch("tabelaProduto/setProdutoUltimoClick", linha.row);
      this.getDetalhesProdutoGrupo(linha.row);
      this.activerow(linha.row);
    },
    ...mapMutations({
      produtosSeleciondosVuex: "ProdutosSelecionados/SET_PRODUTOS_SELECIONADOS",
      qtdeProdutosSeleciondosVuex: "ProdutosSelecionados/SET_QTDE_PRODUTOS_SELECIONADOS"
    }),
    actionBtnMenu(item) {
      switch (item) {
        case 'sazonalidade':
          this.sazonalidade.dialog = true;
          this.sazonalidade.principal = true;
          this.sazonalidade.cadastro = true;
          break;

        case 'comparar-produtos':
          this.dialog_comparar_produtos = true;
          break;

        default:
          break;
      }
    },

    showProgrammaticallyMenu(e) {
      e.evento_padrao.preventDefault();
      this.ATUALIZAR_PRODUTO_SELECIONADO_MENU_CONTEXTO(e.row);

      this.menu.show = false;
      this.x = e.evento_padrao.clientX;
      this.y = e.evento_padrao.clientY;

      this.$nextTick(() => {
        this.menu.show = true;
      });
    },

    adicionarProdutoMultifiliaisNoCarrinho(produtos) {
      const completarCompra = this.cardSelecionado.titulo === 'Completar a Compra';

      produtos.map(item => {
        item.emb_master = this.embalagemMasterAtivada ? 'S' : 'N';
        return item;
      });

      this.addProdutoFullNoCarrinho(produtos, completarCompra)
        .then(() => {
          this.produtosSelecionados = []
          this.buscarPedidos++
          this.cardSelecionado.metodo(this.getFornecedor.id)
        })
        .catch(() => alert('Erro inesperado.'))
    },
    addProdutosCarrinhoMultifiliais(produtos) {
      this.produtosMultifiliaisSelecionados = produtos
      this.produtosMultifiliaisAddComSucesso = false
      this.verificaCompraOportunidade(produtos, 'mult')
    },
    explodirProdutoPorFilial(item = []) {
      this.dialogCompraMultifiliais = true
      this.produtosPorMultifiliais = item
    },
    verificarAtualizacaoDetalhesProduto() {
      // if (this.ativarAtualizacaoDetalhesProduto) {
      //   const FILTRA_PRODUTO_SELECIONADO = item => (item.id_grupo + item.idproduto) == this.selectedId
      //
      //   const PRODUTO_SELECIONADO = this.tabelaCompra.filter(FILTRA_PRODUTO_SELECIONADO)
      //
      //   if (!PRODUTO_SELECIONADO.length) {
      //     this.getDetalhesProdutoGrupo(this.tabelaCompra[0])
      //     this.activerow(this.tabelaCompra[0])
      //   }
      // }
    },
    distintasCLasses(filtros) {
      let classes = {};

      filtros.forEach((item) => {
        if (!classes[item.classe]) {
          classes[item.classe] = false;
        }
      });

      return classes;
    },
    atualizarPedidosCarrinho() {
      this.buscarPedidos++;
    },
    ...mapMutations("app", ["setDialogSilenciarProduto"]),
    ...mapMutations("notificacaoProdutoSilenciado", ["setProdutoSilenciadoEditar",]),
    verificaCompraOportunidade(produto, acao = "") {
      let compraOportunidade = false;

      if (this.ativaCompraOportunidade === "S") {
        this.armazenaItem.acaoCompraOportunidade = acao;

        for (let i = 0; i < produto.length; i++) {
          let qtde = parseFloat(parseFloat(produto[i].sugestao));
          let sugestao_fixa = parseFloat(produto[i].sugestao_fixa);

          if (qtde > sugestao_fixa) {
            compraOportunidade = !compraOportunidade;
            break;
          }
        }
      }

      if (compraOportunidade) {
        this.dialogMotivosCompra = true;
        this.buscarMotivosCompra();
      } else {
        if (acao === "mult") {
          this.addProdutosCarrinhoGrupo();
        } else {
          this.addCarrinhoGrupo(produto[0]);
        }
      }
    },
    navegacaoLinhasPelasSetas(produto, seta) {
      if (this.$store.getters['loading/qtde_requisicoes'] > 0) return;

      const proximo_produto = this.itemsTabelaCompra[produto.index_of + seta] || null;

      if (!proximo_produto) return;

      this.selectedId = proximo_produto.id_grupo + proximo_produto.idproduto;
      this.ativarProdutoNoComecoOuFimDoScrollTabela();

      const scrollTop = ((proximo_produto.index_of + 1) * this.altura_item) - (this.ALTURA_TABELA_PRODUTOS / 2);
      this.$refs.tabelaProdutos.$refs.contentTableRef.scrollTop = scrollTop;
    },
    ativarProdutoNoComecoOuFimDoScrollTabela() {
      const { scrollTop, scrollHeight } = this.$refs.tabelaProdutos.$refs.contentTableRef;

      const comeco_scroll_tabela = scrollTop === 0;
      const fim_scroll_tabela = scrollTop + (this.ALTURA_TABELA_PRODUTOS) >= (scrollHeight - 5);

      if (comeco_scroll_tabela || fim_scroll_tabela) {
        this.ativarProdutoSelecionadoPelaNavegacaoSetas();
      }
    },
    ativarProdutoSelecionadoPelaNavegacaoSetas() {
      clearTimeout(this.time_focus);

      this.time_focus = setTimeout(() => {
        this.ativarFocuCursorEmInputSugestao();
      }, 1);
    },
    scrollSysDataTable() {
      this.ativarProdutoSelecionadoPelaNavegacaoSetas();
    },

    fecharDialogMotivoCompra() {
      this.$v.$reset();
      this.dialogMotivosCompra = false;
      this.selects.motivosCompra.values = [];
    },
    buscarMotivosCompra() {
      if (!this.selects.motivosCompra.items.length > 0) {
        const headers = this.Helpers.iniciarRequisicao();

        this.$store.dispatch(
          "loading/addRequisicao",
          CompraAPI.getMotivosCompraOportunidade(headers)
            .then((response) => {
              const token = response.data.token;
              localStorage.setItem("token", token);

              this.selects.motivosCompra.items = response.data.motivos;
              this.selects.motivosCompra.values = [];
            })
            .catch(() => {
              this.Helpers.logout();
            })
        );
      } else {
        this.selects.motivosCompra.values = [];
      }
    },
    mostrarDetalhesDoFornecedor(simNao) {
      if (!simNao && this.tabelaCompra.length == 0) return false;

      this.$emit("detalhesFornecedor", simNao);
    },
    titleIndicadorFatorAtuacao(fator_atuacao) {
      let aumentoReducao = "";

      if (parseFloat(fator_atuacao) > 1) {
        aumentoReducao = "Aumento na compra de ";
      } else if (parseFloat(fator_atuacao) < 1) {
        aumentoReducao = "Redução na compra de ";
      }

      return (
        aumentoReducao +
        Math.abs(100 * parseFloat(fator_atuacao) - 100)
          .toFixed(2)
          .replace(".", ",") +
        "%"
      );
    },

    siglaGrupo(id) {
      let sigla = this.gruposCompra.filter((item) => item.id === id);
      if (sigla.length === 0 || !sigla[0].sigla) {
        return "";
      }
      return sigla[0].sigla;
    },

    consolidarCompraParaUmaFilialMulfiliais({ filial }) {
      this.addProdutosCarrinhoGrupo(null, filial);
    },

    addProdutosCarrinhoGrupo(item = null, filial_consolidacao_sugestao = null) {
      if (item) {
        this.produtosSelecionados = item;
      }

      this.$v.$touch();

      if (this.$v.$invalid) {
        return;
      }

      const produtosAdicionados = [];

      let usuario_id = localStorage.getItem("id");

      const qtdeCompraValidaComLoteMinimo = (item) => {
        return this.verificaSeMultiploDeLoteMinimo(item)
      }

      const listaProdutos = this.filialCompra == -1
        ? this.produtosMultifiliaisSelecionados
        : this.PRODUTOS_SELECIONADOS_VALIDOS

      const produtos_validos_para_adicionar_no_carrinho = listaProdutos.filter(item => item.sugestao > 0 && !item.compra_produto_nao_confirmada_no_erp);

      produtos_validos_para_adicionar_no_carrinho.forEach((produto) => {
        if (qtdeCompraValidaComLoteMinimo(produto) && this.verificarVendaFuturaValida(produto)) {
          const novoProduto = {
            fornecedor: this.getFornecedor.id,
            produto: produto.idproduto,
            qtde: this.getQtdePedidoConvertida(produto),
            sugestao: produto.sugestao_fixa,
            grupo: produto.id_grupo,
            filial: (this.filialCompra == -1) ? produto.filial : this.filialCompra,
            tipo_compra: produto.tipo,
            usuario: parseInt(usuario_id),
            motivos: this.selects.motivosCompra.values,
            analiseGrupoFornecedores: localStorage.analiseGrupoFornecedores,
            produto_eh_combinacao: produto.produto_eh_combinacao || false,
            considerar_estoque_grupo: this.CONSIDERAR_ESTOQUE_GRUPO_COMPRA_MULTI_FILIAL ? 'S' : 'N',
            emb_master: this.embalagemMasterAtivada ? 'S' : 'N',
          }

          if (produto.preco_custo) {
            novoProduto.preco_custo = produto.preco_custo
          }

          produtosAdicionados.push(novoProduto);
        }
      });

      if (produtosAdicionados.length === 0) {
        this.produtosSelecionados = []
        this.produtosMultifiliaisSelecionados = [];
        alert('Nenhum produto válido para ser adicionado ao carrinho de compras.')
        return;
      }

      if (this.COMPRA_DISTRIBUIDA_POR_FILIAL) {
        this.adicionarProdutosNoCarrinhoCompraPorMultifilialVersao2(produtosAdicionados, filial_consolidacao_sugestao);
        return;
      }

      const headers = this.Helpers.iniciarRequisicao();

      this.$store.dispatch(
        "loading/addRequisicao",
        CarrinhoAPI.addMultCarrinhoGrupo(
          headers,
          JSON.stringify(produtosAdicionados)
        )
          .then((response) => {
            const token = response.data.token;
            localStorage.setItem("token", token);
            this.produtosSelecionados = [];
            this.produtosMultifiliaisSelecionados = [];
            this.cardSelecionado.metodo(this.getFornecedor.id);
            this.atualizarPedidosCarrinho();
            this.fecharDialogMotivoCompra();
            this.produtosMultifiliaisAddComSucesso = true
            this.produtosAdicionadosNoCarrinho(this.PRODUTOS_SELECIONADOS_VALIDOS);
          })
          .catch(() => {
            this.Helpers.logout();
          })
      );
    },
    getQtdePedidoConvertida(produto) {
      if (!this.embalagemMasterAtivada) {
        return parseFloat(produto.sugestao);
      }

      if (produto.tipo_fator_conversao === 'D') {
        return parseFloat(produto.sugestao * produto.multiplo_compra);
      }

      return parseFloat(produto.sugestao / produto.multiplo_compra);
    },
    adicionarProdutosNoCarrinhoCompraPorMultifilialVersao2(produtos, filial_consolidacao_sugestao = null) {
      api.post("compras/produtos/carrinho/produtos/multifiliais", { produtos, filial_consolidacao_sugestao })
        .then(() => {
          this.produtosSelecionados = []
          this.buscarPedidos++
          this.cardSelecionado.metodo(this.getFornecedor.id)
        })
        .catch(logout);
    },
    addCarrinhoGrupo(produto) {
      this.$v.$touch();

      if (!this.$v.$invalid) {
        this.ativarAtualizacaoDetalhesProduto = true;
        this.$store.dispatch(
          "loading/addRequisicao",
          this.$store
            .dispatch("carrinho/Store", {
              fornecedor: this.getFornecedor.id,
              produto: produto.idproduto,
              qtde: this.getQtdePedidoConvertida(produto),
              sugestao: Number(produto.sugestao_fixa) < 0 ? '0' : produto.sugestao_fixa, // Garantir que sugestão negativa seja adicionada como 0 no carrinho
              grupo: produto.id_grupo,
              filial: this.grupoCompra > 0 ? this.filialCompra : 0,
              tipo_compra: produto.tipo,
              motivos: this.selects.motivosCompra.values,
              analiseGrupoFornecedores: localStorage.analiseGrupoFornecedores,
              produto_eh_combinacao: produto.produto_eh_combinacao || false,
              emb_master: this.embalagemMasterAtivada ? 'S' : 'N',
            })
            .then(() => {
              this.atualizarPedidosCarrinho();
              this.produtosSelecionados = [];
              this.fecharDialogMotivoCompra();
              this.produtosAdicionadosNoCarrinho(produto);
              this.reativarNavegacaoPelasSetasNoProximoProduto(produto);
            })
        );
      }
    },
    reativarNavegacaoPelasSetasNoProximoProduto(produto) {
      setTimeout(() => this.navegacaoLinhasPelasSetas(produto, (produto.index_of > 0) ? -1 : 0), 10);
    },
    produtosAdicionadosNoCarrinho(produtos) {
      if (typeof produtos === 'object') {
        this.$store.dispatch("tabela_compra/produtosAdicionadosNoCarrinho", [produtos]);
      } else {
        this.$store.dispatch("tabela_compra/produtosAdicionadosNoCarrinho", produtos);
      }
    },
    activerow(item) {
      const { id_grupo, idproduto } = item
      this.selectedId = id_grupo + idproduto;
      this.ativarFocuCursorEmInputSugestao();
    },
    ativarFocuCursorEmInputSugestao() {
      const element = document.getElementById(this.selectedId);

      if (element && element.focus) {
        element.focus();
      }
    },

    getDetalhesProdutoGrupo(item) {
      if (this.$store.getters['loading/qtde_requisicoes'] > 0) return;

      this.activerow(item);
      this.armazenaItem = item;

      const headers = this.Helpers.iniciarRequisicao();

      const params = {
        produto: item.idproduto,
        fornecedor: item.idfornecedor,
        grupo: item.id_grupo,
        filial: parseInt(this.filialCompra),
        produto_eh_combinacao: item.produto_eh_combinacao ? 'S' : 'N'
      };

      this.$store.dispatch(
        "loading/addRequisicao",
        CompraAPI.getDetalhesProdutoGrupo(headers, params)
          .then((response) => {
            const { token, produto, detalhe_ultima_compra, estoque_filiais, mediasSaidas } = response.data;
            localStorage.setItem("token", token);
            this.$store.dispatch("detalhe_produto/setProduto", produto);
            this.$store.dispatch("detalhe_produto/setUltimaCompra", detalhe_ultima_compra);
            this.$store.dispatch("detalhe_produto/setEstoqueFiliais", estoque_filiais);
            this.$store.dispatch("detalhe_produto/setAnalise", mediasSaidas);
            this.ativarAtualizacaoDetalhesProduto = true;
            this.mostrarDetalhesDoFornecedor(false);
            this.activerow(item);
          })
          .catch(() => this.Helpers.logout())
      );
    },

    atualizarDetalhesProdutoGrupo(item) {
      let carregar_tabela = this.cardSelecionado.metodo(this.getFornecedor.id);

      setTimeout(() => {
        this.getDetalhesProdutoGrupo(item);

        this.activerow(item);

        setTimeout(() => this.$store.dispatch("tabelaProduto/setCountAbrirDetalhesProduto"), 1000);

      }, carregar_tabela);
    },

    atualizarCamposOrdenados(campos) {
      this.campos_em_ordenacao = campos;
      this.$forceUpdate();
    }
  },
};
</script>
<style scoped>
.div-table-itens {
  padding: 1%;
}

.titulo-table-itens {
  color: #042333;
}

.dot {
  height: 15px;
  width: 15px;
  border-radius: 50%;
  display: inline-block;
}

.div-search {
  padding: 0% 0% 0% 0%;
  margin: -1% 0% -4% 0%;
}

.selected_row {
  background-color: rgba(224, 224, 224, 1) !important;
}

.perc-custo-vs-custo-base {
  padding: 5px;
  background: rgba(0, 0, 0, 0.1);
  border-radius: 10px;
  font-size: 0.75rem;
  color: #111;
}

#footer-data-table {
  border: 1px solid #e8e8e8;
  border-bottom-left-radius: 5px;
  border-bottom-right-radius: 5px;
}
</style>

<style>
.classe-fixar-coluna-checkbox-tabela-compras #column-first {
  background-color: white;
  position: sticky !important;
  z-index: 1 !important;
  min-width: 32px;
  max-width: 32px;
  left: 0;
  right: auto;
  padding-right: 11px;
  border: 10;
}

.sazonalidade-item-legenda .sazonalidade_default td:first-child {
  border-left: rgba(0, 0, 0, 0.123) 5px solid;
  border-top-left-radius: 10px !important;
  border-bottom-left-radius: 10px !important;
}

.sazonalidade-item-legenda .emandamento td:first-child {
  border-left: #4caf50 5px solid;
  border-top-left-radius: 10px !important;
  border-bottom-left-radius: 10px !important;
}

.sazonalidade-item-legenda .sazonalidadee td:first-child {
  border-left: #f44336 5px solid;
  border-top-left-radius: 10px !important;
  border-bottom-left-radius: 10px !important;
}

.sazonalidade-item-legenda .finalizado td:first-child {
  border-left: #9e9e9e 5px solid;
  border-top-left-radius: 10px !important;
  border-bottom-left-radius: 10px !important;
}

.sugestao {
  padding-top: 0px !important;
  margin-top: 0px !important;
}

.sugestao input {
  text-align: center !important;
}

.sugestao .v-text-field__details {
  display: none !important;
}

.sugestao .v-text-field {
  padding-top: 0;
  margin-top: 0;
}

.v-input--selection-controls__input {
  margin-right: 0px !important;
  margin-left: 6px !important;
}

.v-input--selection-controls {
  margin-top: 0px !important;
  padding-top: 0px !important;
}

.v-application--is-ltr .v-data-footer__select .v-select {
  margin: 6px 0 12px 16px;
}

.quantidade input {
  text-align: center;
}

.valor input {
  text-align: center;
}
</style>

<style scope>
.v-autocomplete__content .v-list-item__content {
  width: 437px;
}

.v-autocomplete__content .v-list-item__title {
  white-space: normal;
}

.v-autocomplete__content .v-list-item__action {
  margin-right: 6px;
}

.v-autocomplete__content .v-list-item {
  padding: 0 6px;
}

.v-tooltip__content {
  opacity: 1 !important;
  background-color: rgb(4, 35, 51) !important;
}

.tooltip-bell.v-tooltip__content {
  margin-left: 90px;
  margin-top: -5px;
}
</style>
